import { createNullableProvideInject } from '@collector/shared-ui'

import { VerifyResultSummaryConfig } from '../configuration'

export const [
  provideVerifyResultSummaryConfig,
  injectVerifyResultSummaryConfig,
] = createNullableProvideInject<VerifyResultSummaryConfig>(
  'verifyResultSummaryConfig',
)
